import React, { useMemo } from 'react';

import {
	useClassNames,
} from '@common';

import './Divider.scss';

interface DividerProps {
	gap?: string,
	topGap?: string,
	bottomGap?: string,
	className?: string,
}

function Divider(props: DividerProps): JSX.Element {
	const {
		gap = '10px',
		topGap,
		bottomGap,
		className,
	} = props;

	const
		classes = useClassNames(
			'divider',
			className,
		),
		styles = useMemo(() => ({
			marginTop: topGap || gap,
			marginBottom: bottomGap || gap,
		}), [gap, bottomGap, topGap]);

	return (
		<div className={classes} style={styles} />
	);
}

const MemoisedDivider = React.memo(Divider);

export {MemoisedDivider as Divider};